import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  ICreateTermoUsoUserAcceptRequest,
  IGetLastTermoVersionByTipoResponse,
  IGetTermoUserByUserIdResponse,
  IGetTermoUsoResponse
} from './termoUso.model';

@Injectable({
  providedIn: 'root'
})
export class TermoUsoService {
  constructor(private http: HttpClient) {}

  public GetTermoUso(): Observable<IGetTermoUsoResponse> {
    const url = `${environment.baseURL}TermoUso/GetTermoUserByUserId`;
    return this.http.get<IGetTermoUsoResponse>(url);
  }

  public GetVerifyTermoUserLastVersionByUserId(): Observable<IGetTermoUserByUserIdResponse> {
    const url = `${environment.baseURL}TermoUso/GetVerifyTermoUserLastVersionByUserId`;
    return this.http.get<IGetTermoUserByUserIdResponse>(url);
  }

  public GetLastTermoVersionByTipo(
    tipoTermo: number
  ): Observable<IGetLastTermoVersionByTipoResponse> {
    const url = `${environment.baseURL}TermoUso/GetLastTermoVersaoByTipo?TipoTermo=${tipoTermo}&IsEpsa=false`;
    return this.http.get<IGetLastTermoVersionByTipoResponse>(url);
  }

  public CreateTermoUsoUserAccept(
    request: ICreateTermoUsoUserAcceptRequest
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const url = `${environment.baseURL}TermoUso/CreateTermoUsoUserAccept`;

    return this.http.post<any>(url, request, { headers });
  }
}
